// SAT Stimmen™ — Sales-Page-Konfiguration für die 6 Stimmenprodukte
// Basis: Mastermatrix-Dokument (2026-02).
// Alle Preise sind bewusst NICHT hier — das ist ein Anfrage-first-Modell.

export const VOICES = {
  frauenstimme: {
    slug: "frauenstimme",
    label: "SAT Frauenstimme™",
    hero_asset: "FRA-01",
    kicker: "Für die weibliche Stimme im Innen und Aussen",
    title: "Deine Stimme",
    title2: "als Frau.",
    headline: "Ein geschützter Entwicklungsraum, in dem deine weibliche Stimme wieder klar, klar und tragend wird.",
    lead: "Die SAT Frauenstimme™ ist ein Bildungsformat für Frauen, die ihre Stimme — im Sprechen, im Fühlen, im Führen — bewusst gestalten möchten. Keine Therapie, keine Heilversprechen — sondern Übung, Klarheit, Verkörperung.",
    accent: "#C94A5C",
    bg: "linear-gradient(135deg,#3a1420 0%,#0e0512 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Frauen, die im Alltag oft leiser sind, als sie sich fühlen.",
      "Frauen mit Verantwortung — beruflich oder familiär — die in ihrer Kommunikation an Klarheit gewinnen wollen.",
      "Frauen, die spüren: meine Stimme hat mehr Facetten, als ich lebe.",
    ],
    promise_title: "Was du mitnimmst.",
    promises: [
      { t: "Klare Präsenz", d: "Deine Stimme trägt, ohne zu drücken." },
      { t: "Verkörperter Ausdruck", d: "Weniger Kopf, mehr Zwerchfell — deine Stimme kommt aus dem Zentrum." },
      { t: "Grenzen mit Wärme", d: "Ja und Nein aus derselben Quelle sprechen können." },
      { t: "Innere Ruhe im Sprechen", d: "Weniger Reaktion, mehr Wahrhaftigkeit." },
    ],
    curriculum_title: "Was wir gemeinsam tun.",
    curriculum: [
      { n: "I",   t: "Ankommen",         d: "Wie klingt deine Stimme heute — ohne Bewertung?" },
      { n: "II",  t: "Körperliches Fundament", d: "Atem, Aufrichtung, Resonanz." },
      { n: "III", t: "Rollen & Masken",  d: "Welche Stimmen hast du übernommen, die nicht deine sind?" },
      { n: "IV",  t: "Deine Autoritätsstimme", d: "Führen ohne dich zu verlieren." },
      { n: "V",   t: "Zärtlichkeit & Grenze", d: "Beide Stimmen als eine üben." },
      { n: "VI",  t: "Öffentlichkeit",   d: "Deine Stimme im Raum, vor Gruppen, in der Welt." },
    ],
    formats_title: "Format",
    formats: [
      "Kompakt-Seminar (2–3 Tage · Schweiz)",
      "Vertiefungs-Retreat (5 Tage · saisonal)",
      "1:1 Intensiv (auf Anfrage)",
      "Firmen-Format (Führungs-Frauen · Inhouse)",
    ],
    disclaimer: "Bildungsformat — keine Therapie. Bei akuten psychischen Themen empfehlen wir zusätzlich fachliche Begleitung.",
    seo_desc: "SAT Frauenstimme™ — Ein Premium-Bildungsformat für Frauen, die ihre Stimme klar, verkörpert und tragend gestalten möchten.",
  },

  maennerstimme: {
    slug: "maennerstimme",
    label: "SAT Männerstimme™",
    hero_asset: "MAN-01",
    kicker: "Für die männliche Stimme in Wahrheit und Verantwortung",
    title: "Deine Stimme",
    title2: "als Mann.",
    headline: "Ein Raum, in dem Männer ihre Stimme wiederfinden — jenseits von Rolle, Rüstung und Rechtfertigung.",
    lead: "Die SAT Männerstimme™ ist ein Bildungsformat für Männer, die ihren Ausdruck bewusst kultivieren möchten. Nicht lauter — klarer. Nicht härter — echter.",
    accent: "#2E5C3E",
    bg: "linear-gradient(135deg,#0f2418 0%,#050c08 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Männer, die viel tragen und selten sprechen.",
      "Führungspersönlichkeiten, die ihre Ansprache neu gestalten möchten.",
      "Männer, die in Beziehungen weniger reagieren, mehr wahrhaftig sprechen wollen.",
    ],
    promise_title: "Was du mitnimmst.",
    promises: [
      { t: "Wahrhaftige Klarheit", d: "Sprechen, ohne zu kämpfen. Sagen, was ist." },
      { t: "Verwurzelte Präsenz", d: "Deine Stimme aus dem Bauch, nicht aus der Brust." },
      { t: "Konflikt ohne Härte", d: "Grenzen ziehen, ohne zu verletzen." },
      { t: "Verantwortung als Kraft", d: "Ein Ja, das trägt. Ein Nein, das schützt." },
    ],
    curriculum_title: "Was wir gemeinsam tun.",
    curriculum: [
      { n: "I",   t: "Ankommen",              d: "Deine Stimme jenseits der Rolle." },
      { n: "II",  t: "Körper & Boden",        d: "Verwurzeln — bevor du sprichst." },
      { n: "III", t: "Väter & Vorbilder",     d: "Welche Männerstimme hast du gehört — und übernommen?" },
      { n: "IV",  t: "Führung mit Wärme",     d: "Ansprache, die trägt statt drückt." },
      { n: "V",   t: "Verletzlichkeit",       d: "Die stärkste männliche Stimme ist die, die auch weich sein darf." },
      { n: "VI",  t: "Öffentlichkeit",        d: "Deine Stimme im Team, in Beziehungen, in der Welt." },
    ],
    formats_title: "Format",
    formats: [
      "Kompakt-Seminar (2–3 Tage · Schweiz)",
      "Männer-Retreat (5 Tage · Naturlocation)",
      "1:1 Intensiv (auf Anfrage)",
      "Führungs-Format (Executives · Inhouse)",
    ],
    disclaimer: "Bildungsformat — keine Therapie. Bei akuten psychischen Themen empfehlen wir zusätzlich fachliche Begleitung.",
    seo_desc: "SAT Männerstimme™ — Premium-Bildungsformat für Männer: klare, verkörperte, wahrhaftige Stimme in Führung und Beziehung.",
  },

  mutterstimme: {
    slug: "mutterstimme",
    label: "SAT Mutterstimme™",
    hero_asset: "MUT-01",
    kicker: "Für die Stimme, die trägt — und getragen sein darf",
    title: "Deine Stimme",
    title2: "als Mutter.",
    headline: "Ein Raum für Mütter, die ihre Stimme im Muttersein bewusst gestalten möchten — ohne Schuld, ohne Ideal, ohne Vergleich.",
    lead: "Die SAT Mutterstimme™ ist kein Erziehungsratgeber. Es ist ein Bildungsraum, in dem du wieder wahrnimmst, wie du sprichst — mit deinem Kind, deinem Partner, dir selbst.",
    accent: "#C9A36A",
    bg: "linear-gradient(135deg,#2a1e0d 0%,#0d0906 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Mütter, die im Alltag oft lauter oder leiser sind, als sie sein möchten.",
      "Frauen, die den Übergang zur Mutterschaft neu integrieren.",
      "Mütter in Übergangs-Phasen: Kleinkind → Schule · Teenager · Auszug.",
    ],
    promise_title: "Was du mitnimmst.",
    promises: [
      { t: "Sprechen ohne Schuld", d: "Grenzen setzen, ohne dich schuldig zu fühlen." },
      { t: "Zärtlichkeit als Kraft", d: "Wärme, die nicht schwach wirkt." },
      { t: "Deine eigene Stimme neben der Mutterrolle", d: "Frau bleiben, während du Mutter bist." },
      { t: "Klarheit statt Endlosschleife", d: "Ein Satz kann mehr sagen als zehn." },
    ],
    curriculum_title: "Was wir gemeinsam tun.",
    curriculum: [
      { n: "I",   t: "Ankommen",              d: "Wie klingt deine Stimme, wenn du müde bist?" },
      { n: "II",  t: "Der innere Kommentar",  d: "Deine eigene Mutter in dir." },
      { n: "III", t: "Grenze mit Liebe",      d: "Nein sagen, ohne wegzugehen." },
      { n: "IV",  t: "Ansprache statt Anschreien", d: "Klarheit, die auch das Kind trägt." },
      { n: "V",   t: "Selbstbild",            d: "Du bist mehr als deine Mutterrolle." },
      { n: "VI",  t: "Ins Leben",             d: "Deine Stimme im Familien-Alltag." },
    ],
    formats_title: "Format",
    formats: [
      "Wochenend-Seminar (2 Tage · Schweiz)",
      "Mütter-Retreat (4 Tage · saisonal)",
      "1:1 Begleitung",
      "Kleingruppen-Format (max. 8 Mütter · 3 Monate)",
    ],
    disclaimer: "Bildungsformat — keine Therapie und kein Erziehungscoaching. Bei akuten familiären Krisen empfehlen wir zusätzlich fachliche Begleitung.",
    seo_desc: "SAT Mutterstimme™ — Für Mütter, die ihre Stimme im Muttersein klar, warm und tragend gestalten möchten.",
  },

  vaterstimme: {
    slug: "vaterstimme",
    label: "SAT Vaterstimme™",
    hero_asset: "VAT-01",
    kicker: "Die Stimme, die Halt gibt — ohne Härte",
    title: "Deine Stimme",
    title2: "als Vater.",
    headline: "Ein Raum für Väter, die eine Stimme kultivieren möchten, an der Kinder wachsen können — nicht sich ducken müssen.",
    lead: "Die SAT Vaterstimme™ ist ein Bildungsformat für Männer, die Vater sind und ihre Ansprache im Familienleben bewusst gestalten möchten. Nicht als Rollen-Training — als Rückverbindung mit dem, was in dir tragend ist.",
    accent: "#4B2E83",
    bg: "linear-gradient(135deg,#150c2b 0%,#080418 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Väter, die im Alltag zwischen Härte und Rückzug pendeln.",
      "Männer, die ihre eigene Vaterstimme aus der Kindheit spüren — und nicht wiederholen wollen.",
      "Väter in Übergangs-Phasen: Baby · Schulkind · Teenager · Trennung.",
    ],
    promise_title: "Was du mitnimmst.",
    promises: [
      { t: "Ansprache statt Anschreien", d: "Klarheit, die trägt statt drückt." },
      { t: "Präsenz statt Perfektion", d: "Da sein reicht — richtig da sein." },
      { t: "Grenzen mit Wärme", d: "Führen, ohne zu regieren." },
      { t: "Deine eigene Vater-Wunde integrieren", d: "Was du nicht bekommen hast, kannst du geben." },
    ],
    curriculum_title: "Was wir gemeinsam tun.",
    curriculum: [
      { n: "I",   t: "Ankommen",         d: "Wie klingt deine Vaterstimme heute?" },
      { n: "II",  t: "Dein Vater in dir", d: "Welche Ansprache trägst du weiter — bewusst?" },
      { n: "III", t: "Präsenz üben",     d: "Da sein statt fixen." },
      { n: "IV",  t: "Grenze mit Herz",  d: "Nein aus Liebe, nicht aus Angst." },
      { n: "V",   t: "Konflikt & Reparatur", d: "Wenn du daneben lagst — wie machst du es gut?" },
      { n: "VI",  t: "Vermächtnis",       d: "Welche Stimme sollen deine Kinder in sich tragen?" },
    ],
    formats_title: "Format",
    formats: [
      "Wochenend-Seminar (2 Tage · Schweiz)",
      "Väter-Retreat (4 Tage · Naturlocation)",
      "1:1 Begleitung",
      "Vater-Sohn-Format (auf Anfrage)",
    ],
    disclaimer: "Bildungsformat — keine Therapie und kein Erziehungscoaching. Bei akuten familiären Krisen empfehlen wir zusätzlich fachliche Begleitung.",
    seo_desc: "SAT Vaterstimme™ — Für Väter, die eine tragende, warme und klare Stimme im Familienleben gestalten möchten.",
  },

  kinderstimme: {
    slug: "kinderstimme",
    label: "SAT Kinderstimme™",
    hero_asset: "KIN-01",
    kicker: "Für Kinder — und die Erwachsenen, die sie tragen",
    title: "Die Stimme",
    title2: "des Kindes.",
    headline: "Ein sorgfältig kuratierter Bildungsraum, in dem Kinder ihre Stimme wahrnehmen dürfen — sicher, altersgerecht, geschützt.",
    lead: "Die SAT Kinderstimme™ ist ein Bildungsformat für Kinder und Jugendliche, das ausschliesslich mit Einwilligung und Begleitung eines Erziehungsberechtigten gebucht werden kann. Kein Therapieformat, keine Diagnose — sondern ein sicherer Raum für Selbstwahrnehmung, Ausdruck und Verbindung.",
    accent: "#8B7BB8",
    bg: "linear-gradient(135deg,#1d1633 0%,#0a0715 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Kinder & Jugendliche (Alters-Gruppen 8–11 · 12–15 · 16–17), in Absprache mit Eltern.",
      "Familien, die einen geschützten Ausdrucksraum für ihr Kind suchen.",
      "Kinder, die in ihrem Alltag Stimme brauchen — ohne dass es Therapie ist.",
    ],
    promise_title: "Was Kinder mitnehmen.",
    promises: [
      { t: 'Ich darf sagen, was ich fühle.', d: "Ausdruck ohne Bewertung, ohne Note." },
      { t: "Sich selbst kennenlernen", d: "Wer bin ich, wenn keiner schaut?" },
      { t: "Umgang mit inneren Stürmen", d: "Fühlen darf, was da ist." },
      { t: "Vertrauen in die eigene Stimme", d: "Auch wenn sie zittert." },
    ],
    curriculum_title: "Wie wir arbeiten.",
    curriculum: [
      { n: "I",   t: "Ankommen",        d: "Spielerisch, ohne Druck." },
      { n: "II",  t: "Gefühle als Farben", d: "Was ich fühle, hat einen Namen." },
      { n: "III", t: "Meine Stimme",    d: "Laut sein, leise sein, gar nicht sein." },
      { n: "IV",  t: "Grenze",          d: "Nein sagen dürfen — auch zu Erwachsenen." },
      { n: "V",   t: "Verbindung",      d: "Ich mit dir, du mit mir." },
      { n: "VI",  t: "Abschluss",       d: "Was ich mitnehme — mit den Eltern." },
    ],
    formats_title: "Format",
    formats: [
      "Kinder-Werkstatt (1 Tag · nach Alter gestaffelt)",
      "Familien-Format (Kind + 1 Elternteil · 2 Tage)",
      "1:1 Kinderbegleitung (nur nach Elterngespräch)",
    ],
    disclaimer: "Bildungsformat für Minderjährige — KEINE Therapie und KEINE psychologische Diagnose. Bei akuten Themen (Trauma, Ess-/Suizid-/Angststörung) verweisen wir konsequent an fachliche Stellen. Buchung ausschliesslich mit expliziter Einwilligung der Erziehungsberechtigten.",
    is_minor_gated: true,
    seo_desc: "SAT Kinderstimme™ — Sicherer, altersgerechter Bildungsraum für Kinder & Jugendliche. Nur mit Elterneinwilligung.",
  },

  elternstimme: {
    slug: "elternstimme",
    label: "SAT Elternstimme™",
    hero_asset: "ELT-01",
    kicker: "Für Eltern gemeinsam — nicht Mutter oder Vater, sondern beide",
    title: "Eure Stimme",
    title2: "als Eltern.",
    headline: "Ein Bildungsformat für Elternpaare (oder getrennt-erziehende Elternteile), die ihre gemeinsame Ansprache bewusst gestalten möchten.",
    lead: "Die SAT Elternstimme™ ist ein systemisches Bildungsformat. Statt einer Person eine Stimme zu geben, arbeiten wir mit dem, was zwischen euch entsteht — als Team, als Paar, als Erziehungs-Konstellation.",
    accent: "#D4AF37",
    bg: "linear-gradient(135deg,#2b220c 0%,#0f0a04 100%)",
    who_for_title: "Für wen ist dieses Format?",
    who_for: [
      "Elternpaare, die sich in ihren Ansprachen widersprechen.",
      "Getrennt-erziehende Eltern, die ihre gemeinsame Elternstimme neu gestalten.",
      "Familien mit Bonus-Kindern & Patchwork-Konstellationen.",
    ],
    promise_title: "Was ihr mitnehmt.",
    promises: [
      { t: "Ein gemeinsames Ja", d: "Konsens ohne Kompromiss." },
      { t: "Getrennte Klarheit", d: "Jede*r spricht — aber im selben Raum." },
      { t: "Grenzen als Team", d: "Regeln, an die sich Kinder halten können, weil die Erwachsenen sie tragen." },
      { t: "Reparatur nach Konflikt", d: "Modelle, die Kinder lebenslang mitnehmen." },
    ],
    curriculum_title: "Was wir gemeinsam tun.",
    curriculum: [
      { n: "I",   t: "Ankommen",             d: "Wo steht ihr — als Team?" },
      { n: "II",  t: "Eure Herkunfts-Familien", d: "Welche Stimmen mischen sich unbewusst ein?" },
      { n: "III", t: "Konsens finden",       d: "Werte klären, ohne Kompromiss." },
      { n: "IV",  t: "Ansprache als Team",   d: "Wenn ihr euch nicht widersprecht, entsteht Halt." },
      { n: "V",   t: "Konflikt vor Kindern", d: "Streiten dürfen — heilen können." },
      { n: "VI",  t: "Vermächtnis",          d: "Welche Kultur schafft ihr in eurer Familie?" },
    ],
    formats_title: "Format",
    formats: [
      "Eltern-Wochenende (2 Tage · für Paare)",
      "Elternteam-Coaching (5 × 90 Min · digital)",
      "Getrennt-Erziehende Format (2 × 1 Tag)",
      "Patchwork-Format (auf Anfrage)",
    ],
    disclaimer: "Bildungsformat — keine Paartherapie und keine Mediation. Bei hochkonflikthaften Trennungen empfehlen wir zusätzlich fachliche Mediation.",
    seo_desc: "SAT Elternstimme™ — Systemisches Bildungsformat für Elternpaare und getrennt-erziehende Eltern.",
  },
};

export const VOICES_ORDER = [
  "frauenstimme",
  "maennerstimme",
  "mutterstimme",
  "vaterstimme",
  "kinderstimme",
  "elternstimme",
];

export const VOICES_QUALITY_PROMISES = [
  { t: "Bildungsformat", d: "Klar abgegrenzt von Therapie & Heilberufen." },
  { t: "Anfrage-first",  d: "Wir sichten jede Anfrage persönlich — nicht automatisiert." },
  { t: "Kinderschutz",   d: "Für Kinderformate: nur mit expliziter Einwilligung der Erziehungsberechtigten." },
  { t: "Sichere Zahlung", d: "Personalisierter Stripe-Link nach Klärungsgespräch — nie vorher." },
];
